/**
 * On entry to the authentication step, an active signing session goes straight
 * to consent. Web and the app WebView both use this.
 *
 * Cancelling the OS passkey dialog on this same document must not take that
 * path. AuthenticationStep sets enrollmentStartedRef before setup or upgrade
 * and skips this probe afterward.
 */
export function shouldAutoReuseOtpSigningSession(enrollmentStarted = false) {
  return !enrollmentStarted;
}

/**
 * After otp/send reports sessionActive, decide whether to enroll/upgrade a
 * passkey or treat the session as completed SMS auth.
 *
 * Intent must be passed by the click handler. `setRegistering(true)` then
 * `handleSendOTP()` still sees registering=false (setState has not flushed,
 * and handleSendOTP historically omitted it from deps), which is why a second
 * "configure biometrics" tap jumped to Accept and Sign.
 */
export function sessionReuseContinueAction({ forRegistration, forUpgrade } = {}) {
  if (forRegistration) {
    return 'registerPasskey';
  }
  if (forUpgrade) {
    return 'upgradePasskey';
  }
  return 'completeOtpAuth';
}
